import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { DocumentsUploadIntensity, DashboardTabs } from "components";
import { useMutation } from "@tanstack/react-query";
import { getIntensity, getIntensitysite } from "api";
import { IntensityAccordionTable } from "./components";

const leagalBtnStates = {
    LEGAL: "company",
};
export const IntensityTab = () => {
    const [value, setValue] = React.useState("");
    const [uploadAPI, setUploadAPI] = React.useState(false);
    const { data: intensitycompany, mutateAsync: getCompanyIntesityData } = useMutation(getIntensity);
    const { data: intensitysite, mutateAsync: getSiteIntesityData } = useMutation(getIntensitysite);
    const { LEGAL } = leagalBtnStates;

    useEffect(() => {
        getCompanyIntesityData()
        getSiteIntesityData()
    }, [getCompanyIntesityData, getSiteIntesityData])

    useEffect(() => {
        if (uploadAPI) {
            getCompanyIntesityData()
            getSiteIntesityData()
        }
    }, [uploadAPI, getCompanyIntesityData, getSiteIntesityData])

    const handleDeactivate = (val: boolean) => {
        if (val) {
            getCompanyIntesityData()
            getSiteIntesityData()
        }
    }

    const tabs: any = {
        [LEGAL]: [
            {
                label: "Company Level",
                content: <IntensityAccordionTable intensityData={intensitycompany} handleDeactivate={handleDeactivate} isCompanyLevel />,
            },
            {
                label: "Site Level",
                content: <IntensityAccordionTable intensityData={intensitysite} handleDeactivate={handleDeactivate} />,
            },

        ],
    };

    const handleTabChange = (tabName: any) => {
        if (tabName === 0) {
            setValue("Company Level")
        } else {
            setValue("Site Level")
        };
    }
    const handleApiResponse = (e: any) => {
        setUploadAPI(e)
    }
    return (
        <Box >
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', height: '10px', paddingRight: '24px' }}>
                <DocumentsUploadIntensity activeTab={value === "Company Level"} apiResponse={handleApiResponse} />
            </Box>
            <Box>
                <DashboardTabs intensity tabs={tabs[LEGAL]} selectedBtnOption={LEGAL} onTabChange={handleTabChange} />
            </Box>
        </Box>
    )
}
